import * as React from 'react';

const RightChevronCircle = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox='0 0 15 15'
    {...props}
  >
    <g clipPath='url(#chevrona)'>
      <path
        fill='#F2F6FA'
        d='M15 7.5A7.5 7.5 0 1 1 7.5 0 7.508 7.508 0 0 1 15 7.5Zm-13.75 0A6.25 6.25 0 1 0 7.5 1.25 6.257 6.257 0 0 0 1.25 7.5Zm8.384-.884L6.687 3.671l-.881.884L8.75 7.5l-2.92 2.92.883.884 2.92-2.92a1.25 1.25 0 0 0 0-1.768Z'
      />
    </g>
    <defs>
      <clipPath id='chevrona'>
        <path fill='#fff' d='M0 0h15v15H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default RightChevronCircle;
